// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * OnboardingWizard — pantalla de bienvenida (idioma + aspecto).
 *
 * Usa los tokens del tema (\`--bg-card\`, \`--text-primary\`, \`--accent\`…) para
 * que el propio diálogo cambie con el skin/paleta que el usuario prueba.
 */

.ob-overlay {
  position: fixed;
  inset: 0;
  z-index: 20000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(3, 5, 10, 0.72);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  overflow: auto;
}

.ob-card {
  width: min(920px, 100%);
  max-height: calc(100vh - 48px);
  overflow: auto;
  background: var(--bg-card, #0d0f1a);
  color: var(--text-primary, #e2e8f0);
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.1));
  border-radius: var(--radius-xl, 16px);
  box-shadow: var(--shadow-xl, 0 24px 80px rgba(0, 0, 0, 0.55));
  padding: 28px 30px 22px;
}

.ob-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  padding-bottom: 18px;
  border-bottom: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));
}

.ob-eyebrow {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--accent, #6366f1);
  margin-bottom: 6px;
}

.ob-title {
  margin: 0 0 6px;
  font-size: 26px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: -0.015em;
}

.ob-subtitle {
  margin: 0;
  max-width: 620px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-secondary, rgba(226, 232, 240, 0.68));
}

.ob-steps {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 6px;
  flex-shrink: 0;
}

.ob-step {
  width: 26px;
  height: 26px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: var(--text-secondary, rgba(226, 232, 240, 0.6));
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.16));
  background: transparent;
}

.ob-step.is-active {
  color: #fff;
  border-color: transparent;
  background: var(--accent, #6366f1);
  box-shadow: 0 0 0 4px color-mix(in srgb, var(--accent, #6366f1) 22%, transparent);
}

.ob-step.is-done {
  color: var(--accent, #6366f1);
  border-color: var(--accent, #6366f1);
}

.ob-step-line {
  width: 26px;
  height: 1px;
  background: var(--border-color, rgba(255, 255, 255, 0.18));
}

.ob-section {
  padding: 20px 0 4px;
}

.ob-section-head {
  margin-bottom: 14px;
}

.ob-section-title {
  margin: 0 0 4px;
  font-size: 17px;
  font-weight: 700;
}

.ob-section-hint {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: var(--text-secondary, rgba(226, 232, 240, 0.62));
}

/* ── Idiomas ─────────────────────────────────────────────────────────── */

.ob-languages {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 10px;
}

.ob-language {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  text-align: left;
  border-radius: var(--radius-lg, 12px);
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.1));
  background: var(--bg-primary, rgba(255, 255, 255, 0.02));
  color: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
}

.ob-language:hover {
  border-color: color-mix(in srgb, var(--accent, #6366f1) 55%, transparent);
  transform: translateY(-1px);
}

.ob-language.is-active {
  border-color: var(--accent, #6366f1);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent, #6366f1) 18%, transparent);
}

.ob-language-badge {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: #fff;
  background: linear-gradient(135deg, var(--accent, #6366f1), var(--accent-2, #8b5cf6));
}

.ob-language-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.ob-language-name {
  font-size: 14px;
  font-weight: 600;
}

.ob-language-sub {
  font-size: 12px;
  color: var(--text-secondary, rgba(226, 232, 240, 0.58));
}

.ob-language-check {
  margin-left: auto;
  color: var(--accent, #6366f1);
  font-weight: 800;
}

.ob-detected {
  margin: 12px 0 0;
  font-size: 12px;
  color: var(--text-secondary, rgba(226, 232, 240, 0.52));
}

/* ── Aspecto ─────────────────────────────────────────────────────────── */

.ob-theme-block + .ob-theme-block {
  margin-top: 18px;
}

.ob-theme-label {
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-secondary, rgba(226, 232, 240, 0.62));
}

.ob-skins {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 10px;
}

.ob-skin {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px;
  text-align: left;
  border-radius: var(--radius-lg, 12px);
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.1));
  background: var(--bg-primary, rgba(255, 255, 255, 0.02));
  color: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.ob-skin:hover {
  border-color: color-mix(in srgb, var(--accent, #6366f1) 55%, transparent);
}

.ob-skin.is-active {
  border-color: var(--accent, #6366f1);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent, #6366f1) 18%, transparent);
}

.ob-skin-thumb {
  display: flex;
  height: 64px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.ob-skin-thumb__side {
  width: 22%;
  border-right: 1px solid rgba(255, 255, 255, 0.14);
}

.ob-skin-thumb__main {
  position: relative;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  padding: 8px;
}

.ob-skin-thumb__card {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 5px 6px;
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.ob-skin-thumb__line {
  height: 3px;
  width: 62%;
  border-radius: 2px;
  opacity: 0.85;
}

.ob-skin-thumb__line--soft {
  width: 40%;
  opacity: 0.5;
}

.ob-skin-thumb__dot {
  position: absolute;
  right: 8px;
  bottom: 8px;
  width: 14px;
  height: 6px;
  border-radius: 999px;
}

.ob-skin-name {
  font-size: 13px;
  font-weight: 700;
}

.ob-skin-tagline {
  font-size: 11px;
  color: var(--text-secondary, rgba(226, 232, 240, 0.55));
}

.ob-palettes {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(88px, 1fr));
  gap: 8px;
}

.ob-palette {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 7px;
  border-radius: 10px;
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.1));
  background: var(--bg-primary, rgba(255, 255, 255, 0.02));
  color: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.ob-palette:hover {
  border-color: color-mix(in srgb, var(--accent, #6366f1) 55%, transparent);
}

.ob-palette.is-active {
  border-color: var(--accent, #6366f1);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent, #6366f1) 18%, transparent);
}

.ob-palette-thumb {
  display: flex;
  height: 34px;
  overflow: hidden;
  border-radius: 6px;
}

.ob-palette-thumb__side {
  width: 28%;
}

.ob-palette-thumb__main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
  padding: 5px;
}

.ob-palette-thumb__bar {
  height: 5px;
  width: 70%;
  border-radius: 2px;
}

.ob-palette-thumb__btn {
  height: 6px;
  width: 34%;
  border-radius: 999px;
}

.ob-palette-name {
  font-size: 11px;
  font-weight: 600;
  text-align: center;
}

/* ── Pie ─────────────────────────────────────────────────────────────── */

.ob-error {
  margin-top: 14px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 13px;
  color: #fecaca;
  background: rgba(220, 38, 38, 0.18);
  border: 1px solid rgba(248, 113, 113, 0.35);
}

.ob-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));
}

.ob-footer-right {
  display: flex;
  gap: 10px;
}

.ob-link {
  border: 0;
  background: transparent;
  color: var(--text-secondary, rgba(226, 232, 240, 0.62));
  font-size: 13px;
  cursor: pointer;
  padding: 8px 4px;
}

.ob-link:hover:not(:disabled) {
  color: var(--text-primary, #e2e8f0);
}

.ob-primary {
  border: 0;
  border-radius: 10px;
  padding: 11px 18px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(135deg, var(--accent, #6366f1), var(--accent-2, #8b5cf6));
  box-shadow: 0 8px 22px color-mix(in srgb, var(--accent, #6366f1) 30%, transparent);
}

.ob-primary:disabled,
.ob-link:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

@media (max-width: 640px) {
  .ob-overlay {
    padding: 0;
    align-items: flex-end;
  }

  .ob-card {
    max-height: 94vh;
    border-radius: var(--radius-xl, 16px) var(--radius-xl, 16px) 0 0;
    padding: 20px 16px 16px;
  }

  .ob-head {
    flex-direction: column;
    gap: 10px;
  }

  .ob-title {
    font-size: 21px;
  }

  .ob-footer {
    flex-direction: column-reverse;
    align-items: stretch;
  }

  .ob-footer-right {
    width: 100%;
  }

  .ob-primary {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/OnboardingWizard.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;EAChC,2BAA2B;EAC3B,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,mCAAmC;EACnC,mCAAmC;EACnC,+DAA+D;EAC/D,qCAAqC;EACrC,6DAA6D;EAC7D,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,uEAAuE;AACzE;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sDAAsD;EACtD,gEAAgE;EAChE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kCAAkC;EAClC,iFAAiF;AACnF;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,uDAAuD;AACzD;;AAEA,2EAA2E;;AAE3E;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,+DAA+D;EAC/D,wDAAwD;EACxD,cAAc;EACd,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,yEAAyE;EACzE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,iFAAiF;AACnF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,qFAAqF;AACvF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uDAAuD;AACzD;;AAEA,2EAA2E;;AAE3E;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,+DAA+D;EAC/D,wDAAwD;EACxD,cAAc;EACd,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,oCAAoC;EACpC,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,+DAA+D;EAC/D,wDAAwD;EACxD,cAAc;EACd,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,oCAAoC;EACpC,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2EAA2E;;AAE3E;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,uDAAuD;EACvD,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,qFAAqF;EACrF,kFAAkF;AACpF;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,gEAAgE;IAChE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/**\r\n * OnboardingWizard — pantalla de bienvenida (idioma + aspecto).\r\n *\r\n * Usa los tokens del tema (`--bg-card`, `--text-primary`, `--accent`…) para\r\n * que el propio diálogo cambie con el skin/paleta que el usuario prueba.\r\n */\r\n\r\n.ob-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 20000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 24px;\r\n  background: rgba(3, 5, 10, 0.72);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  overflow: auto;\r\n}\r\n\r\n.ob-card {\r\n  width: min(920px, 100%);\r\n  max-height: calc(100vh - 48px);\r\n  overflow: auto;\r\n  background: var(--bg-card, #0d0f1a);\r\n  color: var(--text-primary, #e2e8f0);\r\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.1));\r\n  border-radius: var(--radius-xl, 16px);\r\n  box-shadow: var(--shadow-xl, 0 24px 80px rgba(0, 0, 0, 0.55));\r\n  padding: 28px 30px 22px;\r\n}\r\n\r\n.ob-head {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 24px;\r\n  padding-bottom: 18px;\r\n  border-bottom: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));\r\n}\r\n\r\n.ob-eyebrow {\r\n  display: inline-block;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.12em;\r\n  text-transform: uppercase;\r\n  color: var(--accent, #6366f1);\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.ob-title {\r\n  margin: 0 0 6px;\r\n  font-size: 26px;\r\n  line-height: 1.2;\r\n  font-weight: 700;\r\n  letter-spacing: -0.015em;\r\n}\r\n\r\n.ob-subtitle {\r\n  margin: 0;\r\n  max-width: 620px;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  color: var(--text-secondary, rgba(226, 232, 240, 0.68));\r\n}\r\n\r\n.ob-steps {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding-top: 6px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.ob-step {\r\n  width: 26px;\r\n  height: 26px;\r\n  border-radius: 999px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  color: var(--text-secondary, rgba(226, 232, 240, 0.6));\r\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.16));\r\n  background: transparent;\r\n}\r\n\r\n.ob-step.is-active {\r\n  color: #fff;\r\n  border-color: transparent;\r\n  background: var(--accent, #6366f1);\r\n  box-shadow: 0 0 0 4px color-mix(in srgb, var(--accent, #6366f1) 22%, transparent);\r\n}\r\n\r\n.ob-step.is-done {\r\n  color: var(--accent, #6366f1);\r\n  border-color: var(--accent, #6366f1);\r\n}\r\n\r\n.ob-step-line {\r\n  width: 26px;\r\n  height: 1px;\r\n  background: var(--border-color, rgba(255, 255, 255, 0.18));\r\n}\r\n\r\n.ob-section {\r\n  padding: 20px 0 4px;\r\n}\r\n\r\n.ob-section-head {\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.ob-section-title {\r\n  margin: 0 0 4px;\r\n  font-size: 17px;\r\n  font-weight: 700;\r\n}\r\n\r\n.ob-section-hint {\r\n  margin: 0;\r\n  font-size: 13px;\r\n  line-height: 1.45;\r\n  color: var(--text-secondary, rgba(226, 232, 240, 0.62));\r\n}\r\n\r\n/* ── Idiomas ─────────────────────────────────────────────────────────── */\r\n\r\n.ob-languages {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\r\n  gap: 10px;\r\n}\r\n\r\n.ob-language {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 14px 16px;\r\n  text-align: left;\r\n  border-radius: var(--radius-lg, 12px);\r\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.1));\r\n  background: var(--bg-primary, rgba(255, 255, 255, 0.02));\r\n  color: inherit;\r\n  cursor: pointer;\r\n  transition: border-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;\r\n}\r\n\r\n.ob-language:hover {\r\n  border-color: color-mix(in srgb, var(--accent, #6366f1) 55%, transparent);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.ob-language.is-active {\r\n  border-color: var(--accent, #6366f1);\r\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent, #6366f1) 18%, transparent);\r\n}\r\n\r\n.ob-language-badge {\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: 10px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  font-size: 12px;\r\n  font-weight: 800;\r\n  letter-spacing: 0.04em;\r\n  color: #fff;\r\n  background: linear-gradient(135deg, var(--accent, #6366f1), var(--accent-2, #8b5cf6));\r\n}\r\n\r\n.ob-language-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  min-width: 0;\r\n}\r\n\r\n.ob-language-name {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.ob-language-sub {\r\n  font-size: 12px;\r\n  color: var(--text-secondary, rgba(226, 232, 240, 0.58));\r\n}\r\n\r\n.ob-language-check {\r\n  margin-left: auto;\r\n  color: var(--accent, #6366f1);\r\n  font-weight: 800;\r\n}\r\n\r\n.ob-detected {\r\n  margin: 12px 0 0;\r\n  font-size: 12px;\r\n  color: var(--text-secondary, rgba(226, 232, 240, 0.52));\r\n}\r\n\r\n/* ── Aspecto ─────────────────────────────────────────────────────────── */\r\n\r\n.ob-theme-block + .ob-theme-block {\r\n  margin-top: 18px;\r\n}\r\n\r\n.ob-theme-label {\r\n  display: block;\r\n  margin-bottom: 8px;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n  color: var(--text-secondary, rgba(226, 232, 240, 0.62));\r\n}\r\n\r\n.ob-skins {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\r\n  gap: 10px;\r\n}\r\n\r\n.ob-skin {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  padding: 10px;\r\n  text-align: left;\r\n  border-radius: var(--radius-lg, 12px);\r\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.1));\r\n  background: var(--bg-primary, rgba(255, 255, 255, 0.02));\r\n  color: inherit;\r\n  cursor: pointer;\r\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\r\n}\r\n\r\n.ob-skin:hover {\r\n  border-color: color-mix(in srgb, var(--accent, #6366f1) 55%, transparent);\r\n}\r\n\r\n.ob-skin.is-active {\r\n  border-color: var(--accent, #6366f1);\r\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent, #6366f1) 18%, transparent);\r\n}\r\n\r\n.ob-skin-thumb {\r\n  display: flex;\r\n  height: 64px;\r\n  overflow: hidden;\r\n  border: 1px solid rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.ob-skin-thumb__side {\r\n  width: 22%;\r\n  border-right: 1px solid rgba(255, 255, 255, 0.14);\r\n}\r\n\r\n.ob-skin-thumb__main {\r\n  position: relative;\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  gap: 4px;\r\n  padding: 8px;\r\n}\r\n\r\n.ob-skin-thumb__card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n  padding: 5px 6px;\r\n  border: 1px solid rgba(255, 255, 255, 0.18);\r\n}\r\n\r\n.ob-skin-thumb__line {\r\n  height: 3px;\r\n  width: 62%;\r\n  border-radius: 2px;\r\n  opacity: 0.85;\r\n}\r\n\r\n.ob-skin-thumb__line--soft {\r\n  width: 40%;\r\n  opacity: 0.5;\r\n}\r\n\r\n.ob-skin-thumb__dot {\r\n  position: absolute;\r\n  right: 8px;\r\n  bottom: 8px;\r\n  width: 14px;\r\n  height: 6px;\r\n  border-radius: 999px;\r\n}\r\n\r\n.ob-skin-name {\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n}\r\n\r\n.ob-skin-tagline {\r\n  font-size: 11px;\r\n  color: var(--text-secondary, rgba(226, 232, 240, 0.55));\r\n}\r\n\r\n.ob-palettes {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(88px, 1fr));\r\n  gap: 8px;\r\n}\r\n\r\n.ob-palette {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n  padding: 7px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.1));\r\n  background: var(--bg-primary, rgba(255, 255, 255, 0.02));\r\n  color: inherit;\r\n  cursor: pointer;\r\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\r\n}\r\n\r\n.ob-palette:hover {\r\n  border-color: color-mix(in srgb, var(--accent, #6366f1) 55%, transparent);\r\n}\r\n\r\n.ob-palette.is-active {\r\n  border-color: var(--accent, #6366f1);\r\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent, #6366f1) 18%, transparent);\r\n}\r\n\r\n.ob-palette-thumb {\r\n  display: flex;\r\n  height: 34px;\r\n  overflow: hidden;\r\n  border-radius: 6px;\r\n}\r\n\r\n.ob-palette-thumb__side {\r\n  width: 28%;\r\n}\r\n\r\n.ob-palette-thumb__main {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  gap: 3px;\r\n  padding: 5px;\r\n}\r\n\r\n.ob-palette-thumb__bar {\r\n  height: 5px;\r\n  width: 70%;\r\n  border-radius: 2px;\r\n}\r\n\r\n.ob-palette-thumb__btn {\r\n  height: 6px;\r\n  width: 34%;\r\n  border-radius: 999px;\r\n}\r\n\r\n.ob-palette-name {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  text-align: center;\r\n}\r\n\r\n/* ── Pie ─────────────────────────────────────────────────────────────── */\r\n\r\n.ob-error {\r\n  margin-top: 14px;\r\n  padding: 10px 12px;\r\n  border-radius: 8px;\r\n  font-size: 13px;\r\n  color: #fecaca;\r\n  background: rgba(220, 38, 38, 0.18);\r\n  border: 1px solid rgba(248, 113, 113, 0.35);\r\n}\r\n\r\n.ob-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin-top: 20px;\r\n  padding-top: 16px;\r\n  border-top: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));\r\n}\r\n\r\n.ob-footer-right {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.ob-link {\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--text-secondary, rgba(226, 232, 240, 0.62));\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  padding: 8px 4px;\r\n}\r\n\r\n.ob-link:hover:not(:disabled) {\r\n  color: var(--text-primary, #e2e8f0);\r\n}\r\n\r\n.ob-primary {\r\n  border: 0;\r\n  border-radius: 10px;\r\n  padding: 11px 18px;\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  background: linear-gradient(135deg, var(--accent, #6366f1), var(--accent-2, #8b5cf6));\r\n  box-shadow: 0 8px 22px color-mix(in srgb, var(--accent, #6366f1) 30%, transparent);\r\n}\r\n\r\n.ob-primary:disabled,\r\n.ob-link:disabled {\r\n  opacity: 0.55;\r\n  cursor: not-allowed;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .ob-overlay {\r\n    padding: 0;\r\n    align-items: flex-end;\r\n  }\r\n\r\n  .ob-card {\r\n    max-height: 94vh;\r\n    border-radius: var(--radius-xl, 16px) var(--radius-xl, 16px) 0 0;\r\n    padding: 20px 16px 16px;\r\n  }\r\n\r\n  .ob-head {\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n\r\n  .ob-title {\r\n    font-size: 21px;\r\n  }\r\n\r\n  .ob-footer {\r\n    flex-direction: column-reverse;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .ob-footer-right {\r\n    width: 100%;\r\n  }\r\n\r\n  .ob-primary {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
